import round from 'lodash/round';
import type { RateForDisplay } from './types/RateForDisplay';
import { convertApr } from './convertApr';
import { currencyFormatterNoCents } from '@thesavingsgroup/utils/currencyFormatterNoCents';

export const getRangeForDisplay = ({
  brand,
  lowerApr,
  lowerLoanAmount,
  upperApr,
  upperLoanAmount,
}: {
  brand: string;
  lowerApr: number;
  lowerLoanAmount: number;
  upperApr: number;
  upperLoanAmount: number;
}): RateForDisplay => {
  const lowerAprAsPercent = convertApr(lowerApr).asPercent;
  const upperAprAsPercent = convertApr(upperApr).asPercent;

  const roundedLowerApr = round(lowerAprAsPercent, 2);
  const roundedUpperApr = round(upperAprAsPercent, 2);

  const lowerLoanAmountAsString =
    currencyFormatterNoCents.format(lowerLoanAmount);
  const upperLoanAmountAsString =
    currencyFormatterNoCents.format(upperLoanAmount);

  return {
    aprAsString: `${roundedLowerApr}% - ${roundedUpperApr}%`,
    brand,
    loanAmountAsString: `${lowerLoanAmountAsString} - ${upperLoanAmountAsString}`,
    loanTermAsString: '24mo - 84mo',
  };
};
